module.exports = __webpack_public_path__ + "assets/pro-licences-enable.e69446f9.svg";